import React from 'react'

export const renderWithDefaultValue = <T,>(
  value: T,
  defaultValue = '-',
  suffix?: string,
): T | string | React.JSX.Element => {
  if (typeof value === 'number') return value + (suffix ? ' ' + suffix : '')

  if (value) {
    if (typeof value === 'string') return value + (suffix ? ' ' + suffix : '')
    else
      return (
        <>
          {value}
          {suffix ? ' ' + suffix : ''}
        </>
      )
  }

  return defaultValue
}
